// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + {"83":"three-js","363":"vanta-waves","516":"hexells"}[chunkId] + "." + {"83":"af2eb9a87907ae0b674c","363":"8d946a1c6c963d0143a7","516":"20a29a0967bb5a74fbcd"}[chunkId] + ".bundle.js";
};